<template>
  <div>
    <Header :window="window" v-if="!this.inIframe" :parameters="'projeter'" />
    <div
      :class="
        window.width > 480
          ? !this.inIframe
            ? 'container'
            : 'container-fluid'
          : 'container-fluid'
      "
    >
      <div
        :style="!this.inIframe ? 'padding:20px' : 'padding:0px'"
        v-bind:class="{ 'is-hidden': this.loading }"
      >
        <div
          v-if="this.inIframe"
          style="margin:5px 0px;padding:5px;font-size:14px;"
          class="bloc"
        >
          {{ this.meeting_name }}
        </div>

        <p
          style="text-align:center;padding-top:20px;"
          v-if="this.inIframe && !questions.length"
        >
          {{ $t("public.no_questions") }}
        </p>
        <button-return-colidee
          v-if="this.inIframe && this.tokenType !== 'urlparticipant'"
        />
        <div
          :style="
            !this.inIframe
              ? this.background +
                ';height:90vh; margin:0px;overflow-y:auto;overflow-x:hidden'
              : this.background +
                ';height:94vh; margin:0px;overflow-y:auto;overflow-x:hidden'
          "
        >
          <div
            class="has-text-centered text-mark-info question-mark-infos"
            v-if="!this.inIframe"
          >
            {{
              $t("projeter.rdv", {
                url_textit: url_textit,
                meeting_url_participant: meeting_url_participant
              })
            }}
          </div>
          <br />

          <transition-group name="list-complete" tag="p">
            <div
              v-for="(question, index) in pinnedQuestions.filter(
                x => x.pinned == 1
              )"
              :key="'pinned' + question.id"
            >
              <div class="pinnedQuestion list-complete-item">
                <BlocQuestion :question="question" />
              </div>
            </div>
            <div
              v-for="question in questions.filter(x => x.state == 'published')"
              :key="'normal' + question.id"
              class="list-complete-item"
            >
              <BlocQuestion :question="question" />
            </div>
          </transition-group>
        </div>
      </div>
    </div>
    <br />
    <br />
    <MyFooter window="window" v-if="!this.inIframe" />
  </div>
</template>

<script>
import axios from "axios";
import Header from "@/components/layout/Header";
import MyFooter from "@/components/layout/MyFooter";
import ButtonReturnColidee from "../base/ButtonReturnColidee.vue";
import BlocQuestion from "../../components/animerPage/components/BlocQuestion.vue";

export default {
  name: "Projeter",
  data() {
    return {
      isFullscreen: false,
      questions: [],
      token: "",
      tokenType: "urlparticipant",
      urlType: "",
      meeting_id: "",
      meeting_name: "",
      background: "",
      meeting_url_participant: "",
      loading: true,
      questionPinned: "",
      questionPinnedMedia: "",
      questionPinnedId: -1,
      pinnedQuestions: [],
      url_textit: process.env.URL_TEXTIT,
      url_media: process.env.URL_MEDIA,
      inIframe: false,
      window: {
        width: window.innerWidth
      },
      toggleText: false
    };
  },
  components: {
    Header,
    MyFooter,
    ButtonReturnColidee,
    BlocQuestion
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  updated() {
    this.$nextTick(function() {
      let message = {
        task: "updateHeight",
        height: 600
      };
      window.top.postMessage(message, "*");
    });
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      let message = {
        task: "updateHeight",
        height: 600
      };
      window.top.postMessage(message, "*");
    },
    scrollToTopParent() {
      let message = {
        task: "scrollToTop"
      };
      window.top.postMessage(message, "*");
    },

    getExtension(chemin, type_test) {
      var extensionsIMG = new Array("png", "gif", "jpg", "jpeg");
      var extensionsVIDEO = new Array("mp4");
      var regex = /[^.]*$/i;
      var resultats = chemin.match(regex);
      if (type_test == "video" && extensionsVIDEO.indexOf(resultats[0]) != -1) {
        return 1;
      }
      if (type_test == "image" && extensionsIMG.indexOf(resultats[0]) != -1) {
        return 1;
      }

      return 0;
    },
    affiche_question(laQuestion) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      if (laQuestion) {
        laQuestion = laQuestion.replace(urlRegex, function(url, b, c) {
          var url2 = c == "www." ? "http://" + url : url;
          return (
            '<a class="url_pinned" href="' +
            url2 +
            '" target="_blank">' +
            url +
            "</a>"
          );
        });
      }
      if (this.toggleText) {
        return laQuestion;
      } else {
        return laQuestion.substring(0, 200);
      }
    },
    getQuestionsFirstTime() {
      axios.defaults.headers.common[
        "urlparticipant"
      ] = this.meeting_url_participant;
      axios
        .get(
          process.env.URL_SSO_API +
            "textit/public/meeting/" +
            this.meeting_id +
            "/question"
        )
        .then(response => {
          this.questions = response.data;
          this.pinnedQuestions = response.data;
          this.loading = false;
        })
        .catch(error => {
          window.close();
        });
    },
    pinnedQuestion() {
      if (this.questionPinnedId != -1) return true;
      else return false;
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.scrollToTopParent();
    if (window.location !== window.parent.location) {
      this.inIframe = true;
    } else {
      this.inIframe = false;
    }
    // if we are in colidee or in projeter in suite colidee
    if (this.$route.params.url_moderateur) {
      this.token = this.$route.params.url_moderateur;
      this.tokenType = "urlmoderateur";
      this.urlType = "checkurlmoderateur";
    } else if (this.$route.params.url_participant) {
      this.token = JSON.stringify({
        urlParticipant: this.$route.params.url_participant,
        authorizedPreview: this.$store.getters.authorizedPreview,
        colideeViewResultsClient: false
      });
      this.tokenType = "urlparticipant";
      this.urlType = "checkurlparticipant";
      // langue Colidée
      this.$i18n.locale = this.$route.params.languageColidee;
    }

    axios.defaults.headers.common[this.tokenType] = this.token;
    axios
      .get(process.env.URL_SSO_API + "textit/" + this.urlType)
      .then(response => {
        this.meeting_name = response.data[0].name;
        this.meeting_id = response.data[0].id;
        this.meeting_url_participant = response.data[0].url_participant;
        this.getQuestionsFirstTime();

        if (response.data[0].media) {
          this.background =
            "background-repeat:no-repeat;background-size:cover; background-image:url('" +
            this.url_media +
            response.data[0].media +
            "')";
        } else {
          this.background = "background-color:#fff";
        }

        // création de la room privée pour écouter
        var room = "Room_Textit_" + this.meeting_id;
        this.$socket.emit("room", room);
        console.log("first-connect");
      })
      .catch(error => {
        window.location = "/admin";
      });
  },
  sockets: {
    connect() {
      if (this.meeting_id) {
        var room = "Room_Textit_" + this.meeting_id;
        this.$socket.emit("room", room);
        console.log("re-connect");
      }
    },
    disconnect() {
      console.log("disconnect");
    },
    channel(data) {
      data = JSON.parse(decodeURIComponent(data));
      if (data.type === "NEW_QUESTION") {
        if (data.question.state === "published") {
          this.questions.unshift(data.question);
        } else {
          // Fix un bug où le tableau this.questions se remplissait sans qu'on lui demande
          if (
            Object.values(this.questions).length == 0 &&
            Object.keys(this.questions).length == 0
          ) {
            this.questions = [];
          }
          // Fix un bug où le tableau this.questions se remplissait sans qu'on lui demande
          if (
            Object.values(this.pinnedQuestions).length == 0 &&
            Object.keys(this.pinnedQuestions).length == 0
          ) {
            this.pinnedQuestions = [];
          }
        }
        this.pinnedQuestions.unshift(data.question);

        this.questions = this.questions.filter(
          (thing, index, self) =>
            index === self.findIndex(t => t.id === thing.id)
        );
        this.pinnedQuestions = this.pinnedQuestions.filter(
          (thing, index, self) =>
            index === self.findIndex(t => t.id === thing.id)
        );
        console.log("fin du socket NEW QUESTION", this.questions);
      }
      if (data.type === "DELETE_QUESTION") {
        // questions
        for (var i = this.questions.length - 1; i >= 0; i--) {
          if (this.questions[i].id === data.question.id) {
            this.questions.splice(i, 1);
          }
        }
        // copy pinnedQuestions
        for (var i = this.pinnedQuestions.length - 1; i >= 0; i--) {
          if (this.pinnedQuestions[i].id === data.question.id) {
            this.pinnedQuestions.splice(i, 1);
          }
        }
      }
      if (data.type == "UPDATE_QUESTION") {
        // en  priorité on  cherche si la question est visible à l'écran (index>-1 pour visible ou -1 si pas  présente = pending)
        let index = this.questions.findIndex(
          question => question.id === data.question.id
        );
        // copy pinnedQuestions
        let indexPinned = this.pinnedQuestions.findIndex(
          x => x.id === data.question.id
        );

        // si nouvel état pending et question présente à l'écran alors on la dégage
        if (data.question.state == "pending" && index != -1) {
          this.questions = this.questions.filter(
            question => question.id != data.question.id
          );
        }
        // si published et pas présent on le rajoute
        if (data.question.state == "published" && index == -1) {
          this.questions.unshift(data.question);
        }
        // Si question publiée et déjà proposée en  projection ==> cas de la modification d'un intitule de question
        if (data.question.state == "published" && index != -1) {
          this.questions[index].question = data.question.question;
          this.pinnedQuestions[indexPinned].question = data.question.question;
        }
        // copy pinnedQuestions
        else if (
          data.question.state == "published" ||
          (data.question.state == "pending" && index != -1)
        ) {
          this.pinnedQuestions[indexPinned].question = data.question.question;
        } else {
          this.pinnedQuestions[indexPinned].question = data.question.question;
        }
        // si le toggle 'mise en avant' est à false
        if (data.question.pinned == 0) {
          for (var i = this.pinnedQuestions.length - 1; i >= 0; i--) {
            if (this.pinnedQuestions[i].id == data.question.id) {
              this.pinnedQuestions[i].pinned = 0;
            }
          }
        }
        // si le toggle 'mise en avant' est à true
        if (data.question.pinned == 1) {
          for (var j = this.pinnedQuestions.length - 1; j >= 0; j--) {
            if (this.pinnedQuestions[j].id == data.question.id) {
              this.pinnedQuestions[j].pinned = 1;
            }
          }
        }
      }
    }
  }
};
</script>

<style type="text/css" scoped>
.pageloader {
  background: #424a60;
}
.header {
  background: #424a60;
  height: 60px;
  position: relative;
}

.header h1 img {
  height: 50px;
  margin: 5px;
  vertical-align: middle;
}

.question-mark-infos {
  border: 1px solid #dddbdc;
  background: #fff;
  font-weight: bold;
  padding-bottom: 5px;
  border-radius: 0 0 4px 4px;
}
.text-mark-info {
  font-weight: normal;
  font-size: 14px;
}

.pinnedQuestion {
  margin: 10px;
  padding: 30px;
  min-width: 50px;
  min-height: 50px;
  width: 98%;
  background: #dddbdc !important;
  font-size: 25px;
  -moz-box-shadow: 0px 2px 8px 0px #656565;
  -webkit-box-shadow: 0px 2px 8px 0px #656565;
  -o-box-shadow: 0px 2px 8px 0px #656565;
  box-shadow: 0px 2px 8px 0px #656565;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#656565, Direction=180, Strength=8);
  opacity: 0.95;
}

.list-complete {
  margin-top: 20px 0px;
}

.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin: 10px;
  padding: 20px;
  min-width: 50px;
  min-height: 50px;
  -moz-box-shadow: 0px 2px 8px 0px #656565;
  -webkit-box-shadow: 0px 2px 8px 0px #656565;
  -o-box-shadow: 0px 2px 8px 0px #656565;
  box-shadow: 0px 2px 8px 0px #656565;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#656565, Direction=180, Strength=8);
  background: white;
  opacity: 0.95;
}
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}

.img_jointe {
  margin: 5px 5px 5px 0;
  max-width: 230px;
}
.date-publication {
  font-size: 10px;
  font-style: italic;
  color: #8a898e;
}
.next-link {
  font-size: 12px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Projeter.vue